import { CREATE_USER_EMAIL_REQUEST, CREATE_USER_EMAIL_SUCCESS, CREATE_USER_EMAIL_FAILURE } from '../../constants/user_emails.constants';

export const createUserEmailRequest = (id, email, name) => ({
    type: CREATE_USER_EMAIL_REQUEST, id, email, name,
});
export const createUserEmailRequestSuccess = payload => ({ type: CREATE_USER_EMAIL_SUCCESS, payload });
export const createUserEmailRequestFailure = error => ({ type: CREATE_USER_EMAIL_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/actions/user_emails_actions/create_user_email.actions.js